// The specific reasons this module's backend gives, in the four languages.
//
// Two codes travel INSIDE an error and are not the code it is thrown with:
//
//   · `reasons` — what a generic refusal carries in `details.reason` or
//     `details.code` (`ConflictError(…, 'CONFLICT', { reason: 'ALREADY_CLOSED' })`).
//     errorMessage() says it from `errors.reasons.<REASON>` instead of the
//     generic «that record is no longer in the state you expected».
//   · `fields` — the code of each field of a ValidationError, said by
//     fieldErrors() from `errors.fields.<CODE>` instead of «not a valid value».
//
// Generic field codes (EMPTY, IN_THE_FUTURE, NOT_FOUND…) are the shell's and
// are not repeated here. platform/web/tests/errorReasons.test.js reads the
// backend and fails on a code without its four sentences, and on two
// modules saying one code differently (the shell merges them into one).

const errorReasons = {
  es: {
    fields: {
      BELOW_LAST_READING: 'Es menor que el último kilometraje registrado',
    },
  },
  ca: {
    fields: {
      BELOW_LAST_READING: 'És menor que l’últim quilometratge registrat',
    },
  },
  en: {
    fields: {
      BELOW_LAST_READING: 'Lower than the last odometer reading',
    },
  },
  fr: {
    fields: {
      BELOW_LAST_READING: 'Inférieur au dernier kilométrage enregistré',
    },
  },
}

/** The module's catalogue with these hung from `errors`, locale by locale. */
export function withErrorReasons(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    const own = errorReasons[locale] ?? {}
    merged[locale] = {
      ...catalogue,
      errors: {
        ...catalogue.errors,
        reasons: { ...catalogue.errors?.reasons, ...own.reasons },
        fields: { ...catalogue.errors?.fields, ...own.fields },
      },
    }
  }
  return merged
}

export default errorReasons
